<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="immagine3"><span>Kevin Chen</span></p>
<p class="immagine4"><strong>GHOST TOWN</strong></p>
<p class="immagine1">A NOVEL IN 45 CHAPTERS</p>
<p class="immagine2" id="traduzione"><span><i>Translated from the Mandarin<br/>
   (and the Taiwanese) by Darryl Sterk</i></span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?d243d2b2